import { createContext, useContext } from 'react';
import { noop } from '../../utils/noop.js';

/* ---------- String-union source of truth ---------- */
var COLOR_MODE_VALUES = ['light', 'dark'];
/* ---------- Back-compat exports (deprecated) ---------- */
/** @deprecated Use string literals: 'light' | 'dark' */
// @ts-ignore – allow const + type name reuse for backward compatibility
var ColorMode = {
  Light: 'light',
  Dark: 'dark'
};

/* ---------- Context ---------- */

var ThemeContext = /*#__PURE__*/createContext({
  // use literals internally; shim is only for public API
  mode: 'light',
  updateMode: noop
});
var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

export { COLOR_MODE_VALUES, ColorMode, ThemeContext as default, useTheme };
//# sourceMappingURL=ThemeContext.js.map
